/**
 * Zentrale Konfiguration der Web-App.
 * Werte werden aus Umgebungsvariablen geladen.
 */
export const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'https://api.fanini.live/api',
  appTitle: import.meta.env.VITE_APP_TITLE || 'Faninitiative',
  clerkPublishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || '',
  discordInviteUrl: 'https://discord.com/invite/faninitiative',
} as const;
